import type { ReactNode } from "react";
import { useAutopilotStatus } from "../../lib/autopilotStatus";

type OpenToolTerminalFrameProps = {
  title?: string;
  prompt?: string;
  children: ReactNode;
  className?: string;
  compact?: boolean;
  hideAutopilotStatus?: boolean;
};

export function CodexTerminalFrame({
  title = "opentool",
  prompt,
  children,
  className,
  compact = false,
  hideAutopilotStatus = false,
}: OpenToolTerminalFrameProps) {
  const autopilot = useAutopilotStatus();
  const runtime = autopilot.runtime;
  const state = runtime?.state ?? "offline";
  const detail = autopilot.current_task?.prompt ?? runtime?.last_event ?? "no active runtime";

  return (
    <section className={`opentool-terminal-frame${compact ? " is-compact" : ""}${className ? ` ${className}` : ""}`}>
      <header className="opentool-terminal-frame__chrome">
        <div className="opentool-terminal-frame__lights">
          <span />
          <span />
          <span />
        </div>
        <strong>{title}</strong>
        {!hideAutopilotStatus ? (
          <div className={`opentool-terminal-frame__status is-${state}`}>
            <span className="opentool-terminal-frame__status-label">Autopilot</span>
            <span className="opentool-terminal-frame__status-state">{state}</span>
            <span className="opentool-terminal-frame__status-detail">{detail}</span>
          </div>
        ) : null}
      </header>
      <div className="opentool-terminal-frame__body">
        {prompt ? <div className="opentool-terminal-frame__prompt">{prompt}</div> : null}
        <div className="opentool-terminal-frame__content">{children}</div>
      </div>
    </section>
  );
}
